import { changeRangeValueAction } from './changeRangeValueAction';

export const changeWorkplaceCountMinAction = (value: number): ReturnType<typeof changeRangeValueAction> =>
  changeRangeValueAction({ fieldName: 'workplaceCount', rangeValueKey: 'min', value });
